import {getClientConfig} from 'ultra/configs/general';
import {post} from '../../../Helpers/http';

const {api} = getClientConfig(window)

export function sendTelegramNotification(id, message) {
    const data = {message};
    return post(`${api}/bot/notify/${id}`, data);
}
